export function pad(n) {
  return (n < 10) ? ("0" + n) : n;
}

export function floor(n) {
  return Math.floor(n);
}
